import { render, staticRenderFns } from "./app_copyright.vue?vue&type=template&id=2f06f616&scoped=true&"
var script = {}
import style0 from "./app_copyright.vue?vue&type=style&index=0&id=2f06f616&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f06f616",
  null
  
)

export default component.exports